import reducerRegistry from '@comeon/reducer-registry';

const REDUCER_NAME = 'onboarding';

const SHOW_ONBOARDING = '@komigen/onboarding/SHOW_ONBOARDING';
const HIDE_ONBOARDING = '@komigen/onboarding/HIDE_ONBOARDING';
const UPDATE_ONBOARDING_DISABLED = '@komigen/onboarding/UPDATE_ONBOARDING_DISABLED';

// Selectors
export const selectIsOnboardingOpen = state => state[REDUCER_NAME].isOnboardingOpen;
export const selectIsOnboardingDisabled = state => state[REDUCER_NAME].isOnboardingDisabled;

// Actions
export const setOnboardingDisabled = onboardingIsDisabled => ({
	type: UPDATE_ONBOARDING_DISABLED,
	payload: { onboardingIsDisabled }
});

export const closeOnboarding = () => ({
	type: HIDE_ONBOARDING
});

export const openOnboarding = () => ({
	type: SHOW_ONBOARDING
});

const initialState = {
	isOnboardingOpen: undefined,
	isOnboardingDisabled: undefined
};

const reducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case SHOW_ONBOARDING:
			return { ...state, isOnboardingOpen: true };
		case HIDE_ONBOARDING:
			return { ...state, isOnboardingOpen: false };
		case UPDATE_ONBOARDING_DISABLED:
			return {
				...state,
				isOnboardingDisabled: payload.onboardingIsDisabled
			};
		default:
			return state;
	}
};

reducerRegistry.register(REDUCER_NAME, reducer);

export default reducer;
